import { render, staticRenderFns } from "./_splash.vue?vue&type=template&id=46c208ee&scoped=true"
import script from "./_splash.vue?vue&type=script&lang=js"
export * from "./_splash.vue?vue&type=script&lang=js"
import style0 from "./_splash.vue?vue&type=style&index=0&id=46c208ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c208ee",
  null
  
)

export default component.exports